export default __webpack_public_path__ + "static/media/mail.30c96a51.png";